import { IcInfoWarning } from '@assets/icons/24x24';
import { Box, For, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import ActivationAndFlightPlanMixedViewMap from '@components/cockpit/panels/flightPlan/ActivationAndFlightPlanMixedViewMap';
import { useFlightPlansManagementContext } from '@components/cockpit/panels/flightPlan/FlightPlansManagementContext';
import { ScrollArea } from '@components/ui/ScrollArea';
import { Tooltip } from '@components/ui/tooltip';

import FlightPlanStatusIcon from './FlightPlanStatusIcon';

export default function FlightPlanView() {
  const {
    activationAndFlightPlans,
    selectedActivationAndFlightPlanActivationId,
    setSelectedActivationAndFlightPlanActivationId,
  } = useFlightPlansManagementContext();

  return (
    <HStack width="100%" flex={1} minHeight={0} gap={0.25} backgroundColor="neutral.black">
      <ScrollArea backgroundColor="neutral.850" width="318px" flexShrink={0}>
        <VStack gap={0} height="100%" width="100%" flexShrink={0} userSelect="none">
          <For each={activationAndFlightPlans}>
            {(activationAndFlightPlan) => {
              const isSelected = selectedActivationAndFlightPlanActivationId === activationAndFlightPlan.activation.id;
              return (
                <HStack
                  width="100%"
                  height="58px"
                  flexShrink={0}
                  gap={1}
                  paddingLeft={3}
                  paddingRight={1.5}
                  key={activationAndFlightPlan.activation.id}
                  cursor="pointer"
                  borderBottom="2px solid"
                  borderColor="neutral.900"
                  onClick={() =>
                    setSelectedActivationAndFlightPlanActivationId(
                      selectedActivationAndFlightPlanActivationId === activationAndFlightPlan.activation.id
                        ? null
                        : activationAndFlightPlan.activation.id,
                    )
                  }
                  backgroundColor={isSelected ? 'neutral.850' : 'neutral.800'}
                  _hover={{ backgroundColor: isSelected ? 'neutral.850' : 'neutral.700' }}
                >
                  <Tooltip content={activationAndFlightPlan.flightPlan.name} positioning={{ placement: 'right' }}>
                    <Text fontWeight="medium" lineClamp={1} wordBreak="break-all" marginRight="auto">
                      {activationAndFlightPlan.flightPlan.name}
                    </Text>
                  </Tooltip>
                  <FlightPlanStatusIcon
                    status={activationAndFlightPlan.activation.status}
                    validatedOrRejectedBy={activationAndFlightPlan.activation.validatedOrRejectedBy}
                    validationOrRejectionTime={activationAndFlightPlan.activation.validationOrRejectionTime}
                  />
                  {activationAndFlightPlan.activation.conflicts.length > 0 ? (
                    <Tooltip
                      content={activationAndFlightPlan.activation.conflicts
                        .map((conflit) => conflit.conflictingFlightPlanCode)
                        .join(', ')}
                    >
                      <Icon as={IcInfoWarning} color="red.500" boxSize="24px" />
                    </Tooltip>
                  ) : (
                    <Box backgroundColor="neutral.500" width="8px" height="3px" marginX={1} />
                  )}
                </HStack>
              );
            }}
          </For>
        </VStack>
      </ScrollArea>
      <ActivationAndFlightPlanMixedViewMap />
    </HStack>
  );
}
